import TitleHeader from "@/components/TitleHeader";
import { Flex, Text, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import InvididualIcon from "./assets/individual.png";
import CityIcon from "./assets/city.png";
import YArrowIcon from "./assets/y-arrow.svg";
const SelectType = ({ onSelect }: { onSelect: (type: string) => void }) => {
  const navigate = useNavigate();
  return (
    <Flex sx={{ width: "100%", flexDirection: "column" }}>
      <Text
        sx={{
          marginTop: "24px",
          color: "#848484",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        Select your type
      </Text>
      <Text
        sx={{
          color: "#333",
          fontSize: "20px",
          fontWeight: 700,
          marginTop: "20px",
        }}
      >
        Type
      </Text>
      <Flex sx={{ marginTop: "35px" }} justifyContent="space-between">
        <Flex
          flexDirection="column"
          alignItems="center"
          onClick={() => onSelect("individual")}
        >
          <Flex
            sx={{
              width: "140px",
              height: "140px",
              background: "transparent",
              border: "1px solid #D8762B",
              borderRadius: "50%",
            }}
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={InvididualIcon}
              sx={{
                width: "34px",
              }}
            ></Image>
          </Flex>
          <Text
            sx={{
              color: "#D8762B",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            Individual
          </Text>
          <Image
            src={YArrowIcon}
            sx={{ width: "26px", marginTop: "10px" }}
          ></Image>
        </Flex>

        <Flex
          flexDirection="column"
          alignItems="center"
          onClick={() => onSelect("business")}
        >
          <Flex
            sx={{
              width: "140px",
              height: "140px",
              background: "#D8762B",
              border: "1px solid #D8762B",
              borderRadius: "50%",
            }}
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={CityIcon}
              sx={{
                width: "38px",
              }}
            ></Image>
          </Flex>
          <Text
            sx={{
              color: "#D8762B",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            Business
          </Text>
          <Image
            src={YArrowIcon}
            sx={{ width: "26px", marginTop: "10px" }}
          ></Image>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SelectType;
